import { render, staticRenderFns } from "./HeroIco.vue?vue&type=template&id=2196b21d&"
import script from "./HeroIco.vue?vue&type=script&lang=js&"
export * from "./HeroIco.vue?vue&type=script&lang=js&"
import style0 from "./HeroIco.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports